import React, { useState } from 'react';
import './Contact.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons';
import { faFilePdf, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="contact-page">
      <div className="contact-wrapper">
        <div className="contact-header">
          <h1 className="contact-title">Get In Touch</h1>
          <p className="contact-subtitle">
            Feel free to contact me with any of the methods (form below or social media links attached) below. My inbox is always open and I am happy to connect with you regarding any questions!
          </p>

          <div className="opportunity-note-box">
            <div className="note-status-indicator">
              <span className="pulse-dot"></span>
              <span className="note-badge-text">STATUS</span>
            </div>
            <div className="note-content">
              <p className="note-message">
                <strong>Looking for late 2026 or anytime 2027 internship opportunities</strong> (open to any term).
              </p>
              <span className="note-timestamp">Last updated: August 2026</span>
            </div>
          </div>
        </div>

        <div className="contact-grid">
          {/* Left Column: Quick Info & Direct Links */}
          <div className="contact-info-card">
            <h2 className="info-card-heading">Connect Directly</h2>
            <p className="info-card-sub">Feel free to reach out across any of these channels.</p>

            <div className="contact-links-list">
              <a
                href="mailto:ayaan.nadamal@gmail.com"
                className="contact-link-row"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="link-icon-box">
                  <FontAwesomeIcon icon={faEnvelope} />
                </div>
                <div className="link-text-content">
                  <span className="link-label">Email</span>
                  <span className="link-value">ayaan.nadamal@gmail.com</span>
                </div>
              </a>

              <a
                href="https://www.linkedin.com/in/ayaan-nadamal"
                className="contact-link-row"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="link-icon-box">
                  <FontAwesomeIcon icon={faLinkedin} />
                </div>
                <div className="link-text-content">
                  <span className="link-label">LinkedIn</span>
                  <span className="link-value">linkedin.com/in/ayaan-nadamal</span>
                </div>
              </a>

              <a
                href="https://github.com/Ayu190505"
                className="contact-link-row"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="link-icon-box">
                  <FontAwesomeIcon icon={faGithub} />
                </div>
                <div className="link-text-content">
                  <span className="link-label">GitHub</span>
                  <span className="link-value">github.com/Ayu190505</span>
                </div>
              </a>
            </div>

            <div className="documents-section">
              <h3 className="doc-heading">Documents</h3>
              <div className="doc-buttons-row">
                <a
                  href="https://drive.google.com/file/d/1Tcxl_JHiiWy25BhNDTKpnLurG3in8JWM/view?usp=drive_link"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="doc-btn"
                >
                  <FontAwesomeIcon icon={faFilePdf} /> View Resume
                </a>
                <a
                  href="https://drive.google.com/file/d/1ctNPo9hbtKY2yxmDgyPl9JkysuVaTbli/view?usp=drive_link"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="doc-btn"
                >
                  <FontAwesomeIcon icon={faFilePdf} /> Transcript
                </a>
              </div>
            </div>
          </div>

          {/* Right Column: Contact Form */}
          <div className="contact-form-card">
            <h2 className="form-card-heading">Send a Message</h2>
            <form action="https://api.web3forms.com/submit" method="POST" className="contact-form">
              <input type="hidden" name="access_key" value="985610b2-8e02-4b8c-aacb-d642f54e893c" />
              <input type="hidden" name="redirect" value="/contact" />

              <div className="form-group">
                <label htmlFor="contact-name" className="form-label">Your Name</label>
                <input
                  id="contact-name"
                  type="text"
                  name="name"
                  placeholder="e.g. John Doe"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label htmlFor="contact-email" className="form-label">Your Email</label>
                <input
                  id="contact-email"
                  type="email"
                  name="email"
                  placeholder="e.g. john@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label htmlFor="contact-message" className="form-label">Message</label>
                <textarea
                  id="contact-message"
                  name="message"
                  placeholder="Write your message here..."
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={5}
                  className="form-textarea"
                ></textarea>
              </div>

              <button type="submit" className="form-submit-btn">
                <FontAwesomeIcon icon={faPaperPlane} /> Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
